import { inject, observer } from "mobx-react";

import {
  fn_delivery_call,
  fn_pickup_order,
  fn_delivery_cancel,
  fn_print_receipt,
  fn_show_accept_order_reject,
  fn_show_end_order_cancel,
  fn_show_hooking_order_cancel,
  fn_show_hooking_order_reject,
  fn_show_new_order_reject,
  fn_show_reject_order,
  fn_show_cancel_panda,
  fn_no_show_allowed_time,
} from "function/FnBodyStep";
import {
  fn_cookingPring,
  fn_layerCstView,
  fn_order_complete_layer,
  fn_self_delivery_complet,
  fn_order_payment_alert_show,
} from "function/FnBodyLayer";
import { fn_bridge_order_change, fn_bridge_print } from "function/FnPosBridge";
import {
  getDepositCheck,
  ygyMobileOrderFg,
  apiMobileOrderFg,
  hungryPandaMobileOrderFg,
  posOrdermMbileOrderFg,
} from "utils/Utils";
import { ygy_auto_cancel, fn_cooking_complete } from "http/StepConn";
import { MobileOrderFg, StepCd } from "types";
import {
  isCommonO2OOrder,
  isCookingCompleteValidOrder,
  isHookingOrder,
  isPaidOrder,
  isRecallValidOrder,
} from "utils/CheckerOrderGroups";

const BUTTON_TEXTS = {
  PAYMENT_COMPLETE: "결제완료",
  PAYMENT_PROCESS: "결제진행",
  ORDER_ACCEPT: "주문접수",
  ORDER_CANCEL: "주문취소",
  ORDER_REJECT: "주문거부",
  DELIVERY_CANCEL: "배차취소",
  DELIVERY_REQUEST: "배달요청",
  PICKUP_COMPLETE: "픽업완료",
  PICKUP_PAYMENT: "픽업결제",
  CALL: "호출",
  RECALL: "재호출",
  DELIVERY_COMPLETE: "배달완료",
  COMPLETE_PROCESS: "완료처리",
  COOKING_COMPLETE: "조리완료",
  MOVE_TO_COOKING: "조리중으로 이동",
};

const SUB_TEXTS = {
  LATER_PICKUP: "나중에 픽업",
  PICKUP_PAYMENT_NOTICE: "(픽업 결제 동시에)",
  PICKUP_REQUEST_NOTICE: "(픽업요청 알림발송)",
};

const OrderDetailButton = ({ rootStore, order, type }) => {
  const { searchStore, settingStore, layerStore } = rootStore;

  const printerSetting = settingStore.getPrinterInfo;
  const checkHooking = isHookingOrder(order);
  const checkPaid = isPaidOrder(order);
  const depositCk = getDepositCheck(order);
  const checkRecall = isRecallValidOrder(order);
  const checkCookingComplete = isCookingCompleteValidOrder(order);
  const checkCommonO2O = isCommonO2OOrder(order);

  let printFormCheck = false;
  let disableState = false;
  let disableStateN2 = false;
  let disableStateN3 = false;

  let detailType = "";
  if (
    (searchStore.getCurrStepType === "all" && order.stepType === "READY") ||
    searchStore.getCurrStepType === "ready"
  ) {
    detailType = "ready";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "COOKING") ||
    searchStore.getCurrStepType === "cooking"
  ) {
    detailType = "cooking";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "DELIVERY") ||
    searchStore.getCurrStepType === "delivery"
  ) {
    if ((order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500") {
      detailType = "cooking";
    } else {
      detailType = "delivery";
    }
  } else if (searchStore.getCurrStepType === "end") {
    detailType = "end";
  }
  if (type === "end") {
    detailType = "end";
  }

  if (order.mobileOrderFg === MobileOrderFg.HOOKING) {
    disableState = true;
    if (
      printerSetting.hookingFlag === "Y" &&
      printerSetting.kitchenPrinterFlag === "Y" &&
      printerSetting.usedKitchenPrinterCodes.length > 0
    ) {
      disableState = false;
    }
    if (printerSetting.kitchenPrinterFlag === "N") disableState = false;
  } else if (apiMobileOrderFg(order.mobileOrderFg)) {
    disableState = order.stepCd === StepCd.WAITING;
  }

  if (type === "end" && rootStore.searchStore.getShopCdSaleDate.saleDate != order.saleDate) {
    disableState = true;
  }

  if (
    (order.mobileOrderFg === MobileOrderFg.NAVER || order.mobileOrderFg === MobileOrderFg.CID) &&
    printerSetting.kitchenPrinterSettings.length > 0
  ) {
    printFormCheck = true;
  }

  if (
    detailType === "delivery" &&
    order.orderType === "DELIVERY" &&
    !(!order.dlvStatusFg || order.dlvStatusFg === "00")
  ) {
    disableStateN2 = true;
  }
  if (!(detailType === "ready" || detailType === "cooking" || detailType === "delivery")) {
    disableStateN2 = true;
  }
  if (detailType === "end") {
    if (order.stepCd === StepCd.ORDER_COMPLETED) {
      disableStateN2 = false;
    } else {
      disableStateN2 = true;
    }
  }
  if (
    detailType === "cooking" &&
    order.orderType === "PICKUP" &&
    order.partnerType === "CID" &&
    order.payType === "PAID" &&
    depositCk === true
  ) {
    disableStateN3 = true;
  }

  //요기배달 비활성화
  if (order.stepCd === StepCd.ORDER_COMPLETED && order.mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS) {
    disableStateN2 = true;
  } else if (order.mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS && order.dlvStatusFg === "00") {
    disableStateN2 = true;
  }

  function onClickActionBtn(typeNumber) {
    if (typeNumber === 1) {
      if (printerSetting.kitchenPrinterFlag === "N" && checkHooking) {
        fn_bridge_print(rootStore, "3");
      } else {
        if (checkHooking) {
          if ((detailType === "delivery" || detailType === "end") && order.orderType === "DELIVERY") {
            fn_bridge_print(rootStore, "4");
          } else {
            fn_cookingPring(rootStore);
          }
        } else if (order.mobileOrderFg !== MobileOrderFg.NAVER && apiMobileOrderFg(order.mobileOrderFg)) {
          fn_print_receipt(rootStore, order.mobileOrderNo, true); //재출력
        } else if (
          (order.mobileOrderFg === MobileOrderFg.NAVER || order.partnerType === "CID") &&
          rootStore.settingStore.getKitchenPrintYn === "N"
        ) {
          fn_bridge_print(rootStore, "2");
        } else if (order.mobileOrderFg === MobileOrderFg.NAVER_BOOKING || order.mobileOrderFg === MobileOrderFg.NAVERCONNECT) {
          fn_bridge_print(rootStore, "4");
        } else {
          fn_print_receipt(rootStore, order.mobileOrderNo, printFormCheck);
        }
      }
    } else if (typeNumber === 2) {
      if (detailType === "ready") {
        //테이블주문도 주문거부 팝업
        if (checkHooking) {
          fn_show_hooking_order_reject(rootStore, order.mobileOrderNo);
        } else {
          if (
            // 신규 채널일 경우 주문 사유 팝업 띄우기
            Number(order.mobileOrderFg) > 40 ||
            ygyMobileOrderFg(order.mobileOrderFg) ||
            order.mobileOrderFg === MobileOrderFg.WMPO ||
            order.mobileOrderFg === MobileOrderFg.DDANGYO ||
            order.mobileOrderFg === MobileOrderFg.BMSMILE ||
            order.mobileOrderFg === MobileOrderFg.MUKKEBI ||
            order.mobileOrderFg === MobileOrderFg.DDANGBAEDAL
          ) {
            fn_show_reject_order(rootStore, order.mobileOrderNo, "R");
          } else {
            fn_show_new_order_reject(rootStore, order.mobileOrderNo);
          }
        }
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY" || order.orderType === "PICKUP") {
          if (checkHooking) {
            fn_show_hooking_order_cancel(rootStore, order.mobileOrderNo, "orderCancelDetail Button");
          } else if (hungryPandaMobileOrderFg(order.mobileOrderFg)) {
            fn_show_cancel_panda(rootStore);
          } else {
            if (checkCommonO2O) {
              fn_show_reject_order(rootStore, order.mobileOrderNo, "C");
            } else {
              fn_show_accept_order_reject(rootStore, order.mobileOrderNo, "orderCancelDetail Button");
            }
          }
        } else {
          //TABLE
          if (checkHooking) {
            rootStore.layerStore.setLayerAlertType("order_cancel");
            rootStore.layerStore.setLayerAlertView(true);
          } else {
            fn_show_accept_order_reject(rootStore, order.mobileOrderNo, "orderCancelDetail Button");
          }
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          if (!order.dlvStatusFg || order.dlvStatusFg === "00") {
            fn_delivery_cancel(rootStore, order);
          }
        } else if (checkCommonO2O) {
          fn_show_reject_order(rootStore, order.mobileOrderNo, "C");
        } else {
          fn_show_accept_order_reject(rootStore, order.mobileOrderNo, "orderCancelDetail Button");
        }
      } else if (detailType === "end" && order.stepCd === StepCd.ORDER_COMPLETED) {
        if (!["0", "2"].includes(settingStore.getPosType)) {
          layerStore.setLayerAlertType("order_pos");
          layerStore.setLayerAlertView(true);
        } else {
          // 요기요 주문 취소
          if (order.mobileOrderFg === MobileOrderFg.YOGIYO) {
            fn_show_reject_order(rootStore, order.mobileOrderNo, "C", "end");
            return;
          }
          // 위메프오, 땡겨요, 위글루션 주문 취소
          if (
            order.mobileOrderFg === MobileOrderFg.WMPO ||
            order.mobileOrderFg === MobileOrderFg.DDANGYO ||
            order.mobileOrderFg === MobileOrderFg.BMSMILE ||
            order.mobileOrderFg === MobileOrderFg.DDANGBAEDAL
          ) {
            layerStore.setLayerAlertType("refund_order_cancel");
            layerStore.setLayerAlertView(true);
            return;
          }

          fn_show_end_order_cancel(rootStore, order.mobileOrderNo);
        }
      }
    } else if (typeNumber === 3) {
      if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          if (checkHooking || order.partnerType === "CID" || ygyMobileOrderFg(order.mobileOrderFg)) {
            if (order.payType === "PAID" || order.gstPayAmt > 0) {
              fn_order_complete_layer(rootStore, order.mobileOrderNo);
            } else {
              fn_self_delivery_complet(rootStore, true, order.mobileOrderNo, "orderCompleteDetail Button");
            }
          } else if (checkCookingComplete) {
            fn_cooking_complete(rootStore, order);
          } else {
            fn_order_complete_layer(rootStore, order.mobileOrderNo);
          }
        } else if (order.orderType === "PICKUP") {
          if (order.partnerType !== "CID" && order.mobileOrderFg !== MobileOrderFg.NAVER_BOOKING) {
            fn_order_complete_layer(rootStore, order.mobileOrderNo);
          } else if (order.mobileOrderFg === MobileOrderFg.NAVER_BOOKING) {
            fn_cooking_complete(rootStore, order);
          } else {
            if (order.payType === "PAID" && depositCk === true) {
              fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderCidTakeOutPayment");
              disableState = true;
            } else {
              fn_bridge_order_change(rootStore, "P");
            }
          }
        } else if (order.orderType === "TABLE") {
          if (order.mobileOrderFg === MobileOrderFg.YOGIYO) {
            fn_no_show_allowed_time(rootStore);
          } else {
            fn_order_complete_layer(rootStore, order.mobileOrderNo);
          }
        }
      } else if (detailType === "delivery" && (order.orderType === "PICKUP" || order.orderType === "TABLE")) {
        fn_pickup_order(rootStore);
      } else if (detailType === "delivery" && order.orderType === "DELIVERY" && checkCookingComplete) {
        fn_cooking_complete(rootStore, order);
      }
    } else if (typeNumber === 4) {
      if (detailType === "ready") {
        ygyMobileOrderFg(order.mobileOrderFg)
          ? ygy_auto_cancel(rootStore, order.mobileOrderNo, order.mobileOrderFg, order.morderTypeCd)
          : fn_layerCstView(rootStore, order.mobileOrderNo, "orderAcceptCard Button");
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          fn_delivery_call(rootStore, order.mobileOrderNo, "riderCallDetail Button");
        } else if (order.orderType === "PICKUP") {
          if (!checkPaid) {
            if (depositCk === true) {
              fn_order_complete_layer(rootStore, order.mobileOrderNo);
            } else {
              fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderCidTakeOutPayment");
            }
          } else {
            fn_pickup_order(rootStore);
          }
        } else {
          //TABLE
          if (checkHooking) {
            return null;
          } else if (order.orderType === "TABLE" && order.mobileOrderFg === MobileOrderFg.YOGIYO) {
            fn_order_complete_layer(rootStore, order.mobileOrderNo);
          } else {
            fn_pickup_order(rootStore);
          }
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          if (order.gstPayAmt != 0) {
            fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderCompleteDetail Button");
          } else {
            fn_self_delivery_complet(rootStore, true, order.mobileOrderNo, "orderCompleteDetail Button");
          }
        } else {
          if (order.partnerType != "CID") {
            fn_order_complete_layer(rootStore, order.mobileOrderNo);
          } else {
            if (depositCk === true) {
              fn_order_complete_layer(rootStore, order.mobileOrderNo);
            } else {
              fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderCidTakeOutPayment");
            }
          }
        }
      } else if (detailType === "end") {
        return null;
      } else {
        return null;
      }
    }
  }

  // 1번째 자리 출력 텍스트 반환
  const getPrintButtonText = () => {
    let text = "재출력";
    if (printerSetting.kitchenPrinterFlag === "Y" && checkHooking) {
      text = "주방재출력";
    }
    return <span className="txt">{text}</span>;
  };

  // 2번째 자리 주문 취소 / 주문 거부 텍스트 반환
  const getCancelButtonText = () => {
    let text = BUTTON_TEXTS.ORDER_CANCEL;
    const { orderType } = order;
    if (detailType === "ready") text = BUTTON_TEXTS.ORDER_REJECT;
    else if (detailType === "cooking") text = BUTTON_TEXTS.ORDER_CANCEL;
    else if (detailType === "delivery") {
      text = orderType === "DELIVERY" ? BUTTON_TEXTS.DELIVERY_CANCEL : BUTTON_TEXTS.ORDER_CANCEL;
    }
    return <span className="txt">{text}</span>;
  };

  // 3번째 자리 완료처리 텍스트 반환
  const getCompleteButtonText = () => {
    let text = "";
    let moreText = "";
    const { orderType, partnerType, mobileOrderFg, payType } = order;

    // 조리중일 경우
    if (detailType === "cooking") {
      switch (orderType) {
        case "DELIVERY":
          if (checkHooking || partnerType === "CID" || ygyMobileOrderFg(mobileOrderFg)) {
            text = BUTTON_TEXTS.COMPLETE_PROCESS;
          } else {
            text = checkCookingComplete ? BUTTON_TEXTS.COOKING_COMPLETE : BUTTON_TEXTS.COMPLETE_PROCESS;
          }
          break;
        case "PICKUP":
            if (partnerType !== "CID") {
              text = BUTTON_TEXTS.COMPLETE_PROCESS;
            } else {
              if (payType === "PAID" && depositCk) {
                text = BUTTON_TEXTS.PAYMENT_COMPLETE;
              } else {
                text = BUTTON_TEXTS.PAYMENT_PROCESS;
                moreText = SUB_TEXTS.LATER_PICKUP;
              }
            }
          break;
        case "TABLE":
            text = mobileOrderFg === MobileOrderFg.YOGIYO ? "미방문 처리" : BUTTON_TEXTS.COMPLETE_PROCESS;         
             break;
        default:
          break;
      }
    }

    // 조리 끝 - 요청 했을 경우
    else if (detailType === "delivery") {
      if (orderType === "DELIVERY") {
        text = checkCookingComplete ? BUTTON_TEXTS.COOKING_COMPLETE : "";
      } else if (checkRecall) {
        text = BUTTON_TEXTS.RECALL;
      } else text = "";
    }

    if (!text) {
      return null;
    }

    if (moreText) {
      return (
        <>
          <div className="txt">{text}</div>
          <div className="more">{moreText}</div>
        </>
      );
    }

    return <span className="txt">{text}</span>;
  };

  // 4번째 자리 주문접수 / 배달요청 / 픽업완료 / 픽업결제 / 호출 / 픽업요청 알림발송 텍스트 반환
  const getOrderAcceptButtonText = () => {
    const { orderType, partnerType, mobileOrderFg, payType, orderChannelType } = order;
    let text = "";
    let moreText = "";
    if (detailType === "ready") text = BUTTON_TEXTS.ORDER_ACCEPT;
    // 조리중일 경우
    else if (detailType === "cooking") {
      switch (orderType) {
        case "DELIVERY":
          if (order.mobileOrderFg === MobileOrderFg.DDANGBAEDAL || (checkHooking && partnerType === "DDANGBAEDAL")) {
            text = "";
          } else {
            text = BUTTON_TEXTS.DELIVERY_REQUEST;
          }
          break;
        case "PICKUP":
          if (checkHooking) {
            text = BUTTON_TEXTS.PICKUP_COMPLETE;
          } else {
            if (partnerType === "CID") {
              text = payType === "PAID" && depositCk ? BUTTON_TEXTS.PICKUP_COMPLETE : BUTTON_TEXTS.PICKUP_PAYMENT;
              moreText = payType === "PAID" && depositCk ? "" : SUB_TEXTS.PICKUP_PAYMENT_NOTICE;
            } else {
              text = BUTTON_TEXTS.CALL;
              moreText = SUB_TEXTS.PICKUP_REQUEST_NOTICE;
            }
          }
          break;
        case "TABLE":
          if (checkHooking) text = "";
          else if (mobileOrderFg === MobileOrderFg.YOGIYO) text = BUTTON_TEXTS.COMPLETE_PROCESS;
          else {
            text = BUTTON_TEXTS.CALL;
            moreText = SUB_TEXTS.PICKUP_REQUEST_NOTICE;
          }
          break;
        default:
          text = BUTTON_TEXTS.CALL;
          moreText = SUB_TEXTS.PICKUP_REQUEST_NOTICE;
          break;
      }
    }

    // 조리 끝 - 요청 했을 경우
    else if (detailType === "delivery") {
      if (orderType === "DELIVERY") text = BUTTON_TEXTS.DELIVERY_COMPLETE;
      else text = BUTTON_TEXTS.PICKUP_COMPLETE;
    } else if (detailType === "end" || type === "end") {
      if (order.stepCd === StepCd.ORDER_COMPLETED && posOrdermMbileOrderFg(order.mobileOrderFg)) {
        text = BUTTON_TEXTS.MOVE_TO_COOKING;
      }
    } else text = "";

    if (!text) return null;

    if (moreText) {
      return (
        <>
          <div className="txt">{text}</div>
          <div className="more">{moreText}</div>
        </>
      );
    }

    return <span className="txt">{text}</span>;
  };

  // 버튼 텍스트 반환 함수
  function getButtonTextByType(typeNumber) {
    if (typeNumber === 1) {
      return getPrintButtonText();
    } else if (typeNumber === 2) {
      return getCancelButtonText();
    } else if (typeNumber === 3) {
      return getCompleteButtonText();
    } else if (typeNumber === 4) {
      return getOrderAcceptButtonText();
    }
  }

  const rendering = () => {
    const buttonConfigs = [
      { id: 1, disabled: disableState },
      { id: 2, disabled: disableStateN2 },
      { id: 3, disabled: disableStateN3 },
      { id: 4, disabled: false },
    ];
    return buttonConfigs
      .map(config => ({
        ...config,
        content: getButtonTextByType(config.id),
      }))
      .filter(button => {
        return !!button.content;
      })
      .map(button => {
        return (
          <li key={button.id}>
            <button
              type="button"
              onClick={() => onClickActionBtn(button.id)}
              className={"btn btn_type" + button.id}
              disabled={button.disabled || false}
            >
              {button.content}
            </button>
          </li>
        );
      });
  };

  /// 조건 끝
  return (
    <div className="section_btn">
      <ul>{rendering()}</ul>
    </div>
  );
};

export default inject("rootStore")(observer(OrderDetailButton));
